import React from "react";

function Filter() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        d="M509.978 23.47A15.013 15.013 0 00497 16H15a15.014 15.014 0 00-12.979 7.471 15.01 15.01 0 00-.043 14.97L50.153 121h411.694l48.175-82.559a15.012 15.012 0 00-.044-14.971zM127.295 256l42.856 75h171.698l42.856-75zm-60-105l42.858 75h291.694l42.858-75zM181 361v120c0 8.291 6.709 15 15 15h120c8.291 0 15-6.709 15-15V361H181z"
        data-original="#000000"
      ></path>
    </svg>
  );
}

export default Filter;
